export const MAX_PERSONA_TEXTS_LENGTH = 20
